import React from 'react';
import PartnerPaymentMethods from "./PartnerPaymentMethods";
import BuyerPaymentMethods from "./BuyerPaymentMethods";
import { isSupplierAccount } from "../../util/AccountUtils";

const PaymentMethods = (props) => {
  const { account } = props;

  return (
    isSupplierAccount(account) ?
      <PartnerPaymentMethods key={account.id} account={account}/>
      : <BuyerPaymentMethods account={account} />
  );
};

export default PaymentMethods;
